import { render, staticRenderFns } from "./memberRightAddDialog.vue?vue&type=template&id=ad4158e6&scoped=true"
import script from "./memberRightAddDialog.vue?vue&type=script&lang=js"
export * from "./memberRightAddDialog.vue?vue&type=script&lang=js"
import style0 from "./memberRightAddDialog.vue?vue&type=style&index=0&id=ad4158e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4158e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad4158e6')) {
      api.createRecord('ad4158e6', component.options)
    } else {
      api.reload('ad4158e6', component.options)
    }
    module.hot.accept("./memberRightAddDialog.vue?vue&type=template&id=ad4158e6&scoped=true", function () {
      api.rerender('ad4158e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/components/memberRightAddDialog.vue"
export default component.exports